import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EPSpotlightCategory = ({
  category,
  children
}) => {
  return /*#__PURE__*/_jsxs("div", {
    className: "m-top-4",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "div",
      typography: "heading-25",
      paddingInline: "400",
      paddingBlockEnd: "200",
      children: category
    }), /*#__PURE__*/_jsx("ul", {
      className: "p-x-0",
      children: children
    })]
  });
};
export default EPSpotlightCategory;